import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

export const history = createBrowserHistory();

const store = createStore(
  rootReducer(history),
  compose(applyMiddleware(routerMiddleware(history), thunk)),
);

export default store;
